import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitCamelCase',
    standalone: false
})
export class SplitByCamelCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    // split by camelCase
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
